'use strict';
module.exports = {


    // ApiBaseUrl: 'https://dev.amplofly-aws.com/public/',
    // laravelBaseUrl: 'https://dev.amplofly-aws.com/public/api/',
    // NodeApiBaseUrl: 'https://dev.amplofly-aws.com/api/',

    // ApiBaseUrl: 'http://34.235.134.80:5003/public/',
    // laravelBaseUrl: 'http://34.235.134.80:5003/public/api/',
    // NodeApiBaseUrl: 'http://34.235.134.80:5001/api/',

    ApiBaseUrl: 'https://laravelbackend-demo.amplofly-aws.com/public/',
    laravelBaseUrl: 'https://laravelbackend-demo.amplofly-aws.com/public/api/',
    NodeApiBaseUrl: 'https://nodebackend-demo.amplofly-aws.com/api/',
    REACT_APP_AGENTIC_AI_URL: 'https://demo-agenticai-api.amplofly-aws.com/',
    REACT_APP_AGENTIC_AI_KEY: 'amplo-global-sagnik',

    // laravelBaseUrl: 'http://localhost:8080/api/',
    // ApiBaseUrl: 'http://localhost:5001/api/',
    // NodeApiBaseUrl: 'http://localhost:5001/api/',

    cacheType: 'localStorage',
    debug: false,

};
